import { FormHelperText, Grid, InputLabel } from '@mui/material';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const Control = ({ name, control }) => {
  const { errors, submitCount } = useFormikContext();
  return (
    <>
      <Grid size={2}>
        <InputLabel htmlFor={name} sx={{ mt: 1.25 }}>
          {I18n.t(`WhistleblowerPortalConfig.atts.${name}`)}
        </InputLabel>
      </Grid>
      <Grid size={10}>
        {control}
        <FormHelperText
          sx={{
            display: errors[name] && submitCount > 0 ? 'block' : 'none',
          }}
          error
        >
          {errors[name]}
        </FormHelperText>
      </Grid>
    </>
  );
};

Control.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.node.isRequired,
};

export default Control;
